

















































import {namespace} from 'vuex-class';
import {Component, Vue, Watch} from 'vue-property-decorator';

import BtnDefault from '@/components/UI/BtnDefault.vue';
import TooltipWithClose from '@/components/UI/TooltipWithClose.vue';

const dialog = namespace('dialog')
const profile = namespace('profile')

@Component({
  components: {
    BtnDefault,
    TooltipWithClose,
  },
  name: "Standman"
})
export default class Standman extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any

  @profile.Action('sendInvite') protected sendInvite: any
  
  standman:any =  {
    firstName: '',
    lastName: '',
    email: ''
  }
  emptyEmail:boolean = false
  invalidEmail:boolean = false
  loading:boolean = false
  showTooltip:boolean = true

  validEmail(email:string) {
    let re =  /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    return re.test(email)
  }

  async checkEmail() {
    this.loading = true
    if(!this.standman.email) {
      this.emptyEmail = true
    } else if(!this.validEmail(this.standman.email)) {
      this.invalidEmail = true
    } else {
      await this.sendInvite(this.standman).then(() => {
        this.closeDialog()
      })
    }
    this.loading = false
  }

  closeDialog() {
    this.SetFullDialogShow(false)
    this.standman =  {
      firstName: '',
      lastName: '',
      email: ''
    }
  }

}
